<template>
  <div class="container-center-horizontal page">
    <forget-password-form />
  </div>
</template>

<script>
import ForgetPasswordForm from './ForgetPasswordForm.vue';
export default {
  components: {
   ForgetPasswordForm },
};
</script>

